import React from "react"
import Layout from "../components/layout"

import { GatsbySeo } from "gatsby-plugin-next-seo"
import WebriQForm from "@webriq/gatsby-webriq-form"

// images
import ServicesHeroBg from "../images/pexels-lukas-kloeppel-466684.jpeg"

const fundingForm = ({ data }) => {
  return (
    <Layout>
      <GatsbySeo noindex={true} />
      {/* <PageHeading heading="Insurance" subheading="" BgImg={ServicesHeroBg} /> */}

      <div className="page-header">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-10">
              <div className="header-text">
                <p className="lead">
                  FUNDING ACROSS THE BIPOC INVESTMENT COMMUNITY WHITEPAPER
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="header-bg"
          style={{ backgroundImage: `url(${ServicesHeroBg})` }}
        />
      </div>

      <div className="individuals-page-wrapper">
        <div className="top-content pt-110">
          <div className="container text-center">
            <div className="contact-form">
              <WebriQForm
                data-form-id="8ccc3e84-cd82-4834-96be-b36851b2d1c6"
                name="funding form"
                className="form-newsletter"
                method="POST"
                data-thankyou-url="https://cdn.sanity.io/files/eydex0le/production/36a84c4c87bd564a106e5b10314ad1ed94176f7d.pdf"
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-lg-6">
                    <small className="form-text mt-2">Full Name *</small>
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="text"
                        name="First Name"
                        id="fname"
                        aria-label="first name"
                      />
                    </div>
                    <small className="form-text mt-2">Email *</small>
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="email"
                        name="Email Address"
                        id="email_address"
                        required
                        aria-label="email address"
                      />
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <div className="webriq-recaptcha" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <button
                          className="my-3 solid-btn-homepage"
                          type="submit"
                          style={{
                            outline: "none",
                            border: "none",
                          }}
                        >
                          DOWNLOAD PDF
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </WebriQForm>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default fundingForm
